<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

@if (!isLoading) {
<mat-accordion displayMode="flat">
  <section matSort (matSortChange)="sortChanged($event)" class="header-row">
    <div class="header-cell button-cell">
      <button mat-icon-button (click)="addOrEditTeam(null)" style="outline: none;" title="Add Team"
        [disabled]="!canEdit">
        <mat-icon class="mdi-24px center-self" fontIcon="mdi-plus-circle"></mat-icon>
      </button>
    </div>
    <div class="header-cell one-cell" mat-sort-header="shortName">
      Short Name
    </div>
    <div class="header-cell two-cell" mat-sort-header="email">
      Email
    </div>
    <div class="header-cell one-cell" mat-sort-header="name">
      Full Name
    </div>
    <div class="header-cell four-cell">
      <div class="far-right-cell">
        <mat-form-field class="search-box">
          <input matInput [formControl]="filterControl" placeholder="Search" (click)="applyFilter('')" />
          @if (filterControl.value) {
          <button mat-icon-button matSuffix (click)="clearFilter()" style="outline: none;" title="Clear Search">
            <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
      </div>
    </div>
  </section>

  <section class="scrollable-region">
    @for (team of sortedTeams; track team.id) {
    <mat-expansion-panel [expanded]="editTeam.id === team.id">
      <mat-expansion-panel-header class="row" (click)="togglePanel(team); $event.stopPropagation()">
        <div class="cell button-cell">
          <button mat-icon-button (click)="addOrEditTeam(team); $event.stopPropagation()" style="outline: none;"
            title="Edit {{ team.name }}" [disabled]="!canEdit">
            <mat-icon class="mdi-24px center-self" fontIcon="mdi-square-edit-outline"></mat-icon>
          </button>
          <button mat-icon-button (click)="deleteTeam(team); $event.stopPropagation()" style="outline: none;"
            title="Delete {{ team.name }}" [disabled]="!canEdit">
            <mat-icon class="mdi-24px center-self" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        </div>
        <div class="cell one-cell center-self">
          {{ team.shortName }}
        </div>
        <div class="cell two-cell center-self">
          {{ team.email }}
        </div>
        <div class="cell five-cell center-self">
          {{ team.name }}
        </div>
      </mat-expansion-panel-header>
      @if (team.id === editTeam.id) {
      <div class="sub-panel">
        <app-admin-team-users [teamId]="team.id" [canEdit]="canEdit"></app-admin-team-users>
      </div>
      }
    </mat-expansion-panel>
    }
  </section>
</mat-accordion>
}

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
